var o = /* @__PURE__ */ ((s) => (s.Last30Days = "last_30_days", s.ThisMonth = "this_month", s.LastMonth = "last_month", s))(o || {}), t = /* @__PURE__ */ ((s) => (s.AllTime = "all_time", s.Last3Months = "last_3_months", s.EvaluationPeriod = "evaluation_period", s))(t || {});
export {
  t as DateRangeCustomFilterEnum,
  o as DateRangeFilterEnum
};
